<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w1200 mauto mt50 textc">
                <div class="textc mt28 mb40  ">
                    <p class="fs36 cfff disinblock posre">
                        <span class="border-bottom1">
                            驾校招生小程序
                        </span>
                    </p>
                </div>
                <P class="pt10 pb20 textc ">
                    <span class=" c1f8 fs42 pr5">多样活动模板 </span>
                    <span class="c43d pl5 fs42">玩转招生营销</span>
                </P>

                
                <div class="posre hauto w100p h520">
                    <!-- <div class=" posab w100p textc  h100p  left0 top0  zoom1 indexbg zindex-1">
                        <div class="w250 h100p disinblock">
                            <img class="w100p h100p" src="../../public/img/img25.png">
                        </div>
                    </div> -->

                    <div v-swiper:mySwiper="swiperOption" class="swiper-container posab  w100p h520  left0 top0 zindex1 zoom1 indexbg">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w70p h90p" src="../../public/img/img268.png">
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w70p h90p" src="../../public/img/img269.png">
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w70p h90p" src="../../public/img/img270.png">
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w70p h90p" src="../../public/img/img271.png">
                            </div>
                            <div class="swiper-slide pt25 pb25 ">
                                <img class="w70p h90p"src="../../public/img/img238.png">
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        <div class="w100p bg129 ">
            <div class="w1200 mauto pt80 pb40">
                <div class="w60p">
                    <p class="fs42 c1f8 pt5 pb5">智能营销获客系统</p>
                    <p class="fs24 c43d pt5 pb5">化被动营销为主动营销</p>
                    <p class="fs15 c666 pt5 pb5 lh24">【驾校招生助手】是基于微信和AI技术开发的智能平台，彻底打通企业管理者、销售与客户之间的关系， 帮助企业对销售人员进行管理，优</p>
                </div>
                <ul class="w100p overflow ml-10 pb10">
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img130.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">流量追踪</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">提升员工专业形象，打造专属私域流量池。</p>
                    </li>
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img131.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">用户锁定</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">快速锁定客户，了解需求不错漏。</p>
                    </li>
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img132.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">全员招生</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">每个员工都可为驾校扩展生源。</p>
                    </li>
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img133.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">二级分销</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">人人都做你的分销商。</p>
                    </li>
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img134.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">爆炸式招生模板</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">个性定制让学员抢着报名的招生方案。</p>
                    </li>
                    <li class="disinblock  textc vertop w1666p  pr10 pl10 box">
                        <img class="w160 h160 " src="../../public/img/img135.png">
                        <p class="fs20 textc c1f8 fbold pb5 ">多种节日热点海报</p>
                        <p class="fs12 textc c666 lh24 pb5 pt5">个性定制一键分发，海量曝光。</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="w100p">
            <div class="w1200 mauto posre " >
                <div class="pt30 pb30 textc lines flexc">
                    <span class="line mr40"></span>
                    <span class="c1f8 fs42 pr5">一套招生程序 </span>
                    <span class="c43d fs42 pl5"> 七大系统加持</span>
                    <span class="line ml40"></span>
                </div>
                <div class="w100p  mt50  textc bg136 posre h500"  >
                    <div class="w100p textc  overflow  "  ref="lightBtn">
                        <div class=" w32p  floatl textl">
                            <transition name="moveLL">
                                <p class="bg43d   pl16 pr16 pt10 pb10 minh80" v-show="show1==1">
                                    <span class="fs20 fbold cfff">智能海报</span>
                                    <span class="fs12  cfff pl10">一键转发快速裂变</span>
                                    <span class="fs12 cfff disblock pt5">
                                        基于微信小程序的企业、个人专属海报，一键转发，即
                                        可实现流量裂变。支持文字、语音、图片等丰富展示形
                                        式，更加立体展示企业/个人形象。
                                    </span>
                                </p>
                            </transition>
            
                            <transition name="moveLL">
                                <p class="bg1f8   pl16 pr16 pt10 pb10 minh80 mt28" v-show="show2==1">
                                    <span class="fs20 fbold cfff">企业商城</span>
                                    <span class="fs12  cfff pl10">全员营销在线交易</span>
                                    <span class="fs12 cfff disblock pt5">
                                        海报/名片小程序自带商城，- .键转发微信好友、朋友圈
                                        即可触达客户流量。通过招募分销的形式，分享海报/名
                                        片成交之后便可获取佣金，真正快速实现社会化营销。
                                    </span>
                                </p>
                            </transition>
                            <transition name="moveLL">
                                <p class="bg43d   pl16 pr16 pt10 pb10 minh80 mt28" v-show="show3==1">
                                    <span class="fs20 fbold cfff">小程序官网</span>
                                    <span class="fs12  cfff pl10">企业形象统一展示</span>
                                    <span class="fs12 cfff disblock pt5">
                                        企业信息、活动等内容实时发布，客户快速了解企业实
                                        力和信誉背景，增强信任感。
                                    </span>
                                </p>
                            </transition>
                        </div>
            
            
                        <div class=" w32p  floatr textl">
                            <transition name="moveRR">
                                <p class="bg1f8   pl16 pr16 pt10 pb10 minh80" v-show="show4==1">
                                    <span class="fs20 fbold cfff">销售狙击眼</span>
                                    <span class="fs12  cfff pl10">客户追踪 实时跟进</span>
                                    <span class="fs12 cfff disblock pt5">
                                    智能获取客户浏览轨迹，通过行为喜好、互动倾向等分析，
                                    构建智能客户画像、并实现标签化管理，保证销售实现精准营销。
                                    </span>
                                </p>
                            </transition>
                            <transition name="moveRR">
                                <p class=" bg43d  pl16 pr16 pt10 pb10 minh80 mt28" v-show="show5==1">
                                    <span class="fs20 fbold cfff">Boss望远镜</span>
                                    <span class="fs12  cfff pl10">智能管理 深度管控</span>
                                    <span class="fs12 cfff disblock pt5">
                                        系统测评员工综合能力，识别有价值员工；实时查看客户情况与销售排名，
                                        全面掌握销售进程；一键交接离职员工，保护企业资产不流失。
                                    </span>
                                </p>
                            </transition>
                            <transition name="moveRR">
                                <p class="bg1f8   pl16 pr16 pt10 pb10 minh80 mt28" v-show="show6==1">
                                    <span class="fs20 fbold cfff">智慧客服</span>
                                    <span class="fs12  cfff pl10">超强话术 高效沟通</span>
                                    <span class="fs12 cfff disblock pt5">
                                    系统测评员工综合能力，识别有价值员工；实时查看客户情况与销售排名，
                                    全面掌握销售进程；一键交接离职员工，保护企业资产不流失。
                                    </span>
                                </p>
                            </transition>
                        </div>
                    </div>
                    
                    <transition name="moveBB">
                        <div class="w100p textc  mt60 "  v-show="show7==1">
                            <div class="w32p disinblock">
                                <p class="bg1f8 textl  pl16 pr16 pt10 pb10 minh80">
                                    <span class="fs20 fbold cfff">二级分销</span>
                                    <span class="fs12  cfff pl10">实现招生营销裂变</span>
                                    <span class="fs12 cfff disblock pt5">
                                        设置驾校分销体系，打造自己的营销帝国。全员招生，
                                        每个员工都可为驾校扩展生源，人人都做分销商，降低
                                        招生成本，招生提升50%。
                                    </span>
                                </p>
                            </div>
                        </div>
                    </transition>
                </div>

            
            </div>
        </div>
        <div class="w100p mt30  pb40" style="background: #faf9f8;">
            <div class="w1200 mauto ">
                <p class="hauto  posre  pt50 ppp">
                    <span class="fs42 c1f8">海量节日热点海报</span>
                </p>
                <div class="textc">
                    <img class="w70p hauto " src="../../public/img/img214.png">
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'

    export default {
        data() {
            return {
                show1: 0,
                show2: 0,
                show3: 0,
                show4: 0,
                show5: 0,
                show6: 0,
                show7: 0,
                link: 0,
                color: 3,
                titleList: 1,
                logo: 'school',
                bgImg: require('../../public/img/img24.png'),
                swiperOption: {
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true,
                    effect: 'coverflow',
                    slidesPerView: 4,
                    loop: true,
                    centeredSlides: true,
                    speed: 3000,
                    autoplayDisableOnInteraction: false,
                    autoplay: {
                        delay: 2000,

                    },
                    coverflowEffect: {
                        rotate: 10,
                        stretch: 1000,
                        depth: 50,
                        modifier: 0,
                        spaceBetween: 200,
                        slideShadows: false
                    },
                    coverflow: {
                        rotate: 10,
                        stretch: 1,
                        depth: 50,
                        modifier: 3,
                        slideShadows: false
                    }

                },
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            handleScroll() {
                const isElementNotInViewport = function(el) {
                    let rect = el.getBoundingClientRect();
                    return (
                        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
                        rect.bottom <= 0
                    );
                };

                if (isElementNotInViewport(this.$refs.lightBtn)) {
                    this.show1 = 0;
                    this.show2 = 0;
                    this.show3 = 0;
                    this.show4 = 0;
                    this.show5 = 0;
                    this.show6 = 0;
                    this.show7 = 0;
                } else {

                    this.show1 = 1;
                    this.show4 = 1;

                    this.show2 = 1;
                    this.show5 = 1;

                    this.show3 = 1;
                    this.show6 = 1;


                    this.show7 = 1;

                }


            }

        },
        created() {

        },
        mounted() {
            this.$nextTick(() => {
                let timer;
                window.addEventListener("scroll", () => {
                    if (this.isFixed) {
                        this.isFixed = false;
                    }
                    if (timer) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(() => {
                        this.handleScroll();
                    }, 200);
                });
                this.handleScroll();
            });

        },
    }
</script>
<style scoped>
    .bg129 {
        background-image: url('../../public/img/img129.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg136 {
        background-image: url('../../public/img/img136.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .lines {
        text-align: center;
        line-height: 30px;
        display: flex;
    }
    
    .lines .line {
        width: 100px;
        border-top: 2px solid #ccc;
        margin-top: 0px;
    }
    
    .ppp:before {
        content: '';
        position: absolute;
        left: 0%;
        top: auto;
        bottom: -15px;
        right: auto;
        height: 4px;
        width: 100px;
        background-color: #1f82f6;
    }
    
    .qingxie {
        position: absolute;
        left: 0;
        width: 100%;
        top: 50%;
        transform-style: preserve-3d;
        transform: translateY(-50%) rotateX(54deg) rotateZ(-45deg);
    }
    
    .moveLL-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0%);
    }
    
    .moveLL-enter {
        transform: translateX(-100%);
    }
    
    .moveBB-enter-active {
        transition: opacity 0.3s;
    }
    
    .moveBB-enter,
    .moveBB-leave-to {
        opacity: 0;
    }
    
    .moveRR-enter-active {
        transition: all 0.3s linear;
        transform: translateX(0);
    }
    
    .moveRR-enter {
        transform: translateX(100%);
    }
</style>